@if (!hideGlobalLayout) {
  <mibp-support-team-toolbar></mibp-support-team-toolbar>
}
<mibp-addtocart-dialog></mibp-addtocart-dialog>
@if (!isFocusContent && !hideGlobalLayout) {
  <mibp-salesfore-embedded-service></mibp-salesfore-embedded-service>
}
@if (isLoggedIn && canSeeCart && !hideGlobalLayout) {
  <mibp-cart-quickview></mibp-cart-quickview>
}
<mibp-google-maps-script></mibp-google-maps-script>
<mibp-unhandled-exception-dialog></mibp-unhandled-exception-dialog>
@if (enableBugReport && !hideGlobalLayout) {
  <mibp-devops-feedback></mibp-devops-feedback>
}
@if (enableResourceStringEditor && !hideGlobalLayout) {
  <mibp-resource-string-editor></mibp-resource-string-editor>
}
<mibp-terms-and-conditions></mibp-terms-and-conditions>

<mibp-dialog title="ContactUs_Title" fullheight="false" size="narrow" (closed)="onContactUsFormClosed()" #newContactDialog>
  <mibp-new-contact-us-form [formData]="newContactUsFormData" (successfullySubmitted)="closeForm($event)"></mibp-new-contact-us-form>
</mibp-dialog>

<mibp-system-message-dialog></mibp-system-message-dialog>
<mibp-feature-tour-component></mibp-feature-tour-component>
<!-- This dialog is used by the DialogService for more basic prompts etc -->
<!-- <mibp-noticebar></mibp-noticebar> -->

<mibp-browser-update-notice></mibp-browser-update-notice>


<section id="application-root" class="application-root" [class.mysandvik-menu-hidden]="isSidebarHidden"
  [class.application-root--registration]="hideGlobalLayout">

  @if (!isFocusContent && !hideGlobalLayout) {
    <header class="application-root__header" id="my-header"
      xstyle="transition: margin 0.25s ease-in-out;">
      <mibp-header></mibp-header>
    </header>
  }

  @if (!isSidebarHidden && !isFocusContent && !hideGlobalLayout) {
    <nav @myToggleTrigger class="application-root__sidebar mysandvik-sidebar media@s-and-larger"
      >
      <mibp-sidebar></mibp-sidebar>
    </nav>
  }

  <div class="application-root__content" [class.application-root__content--focus-content]="isFocusContent"
    xstyle="transition: margin 0.25s ease-in-out;">

    <mibp-application-gate>

      <section id="my-main-container">

        @if (isTestingFeatureManagement && !hideGlobalLayout) {
          <div style="background-color: yellow; padding: 10px;">
            <strong style="font-weight: bold;">NOTICE!</strong> The new <strong>Feature Management</strong> is activated
            for testing in this environment. This means that Features are used instead of Permissions throughout the site.
          </div>
        }

        @if (isSupportTeamMember && hasConfigurationErrors) {
          <div>
            <mibp-system-message #msg [messageType]="msg.Types.Error">
              <h2>GlobalConfig error</h2>
              <ul>
                <li>This is shown because you are a SupportTeamMember</li>
                <li>Errors were detected in GlobalConfig</li>
                <li>See <a href="javascript:void(0)" [ecommerceRouterLink]="['/:lang/operations']">Operations</a> for
              details.</li>
            </ul>
          </mibp-system-message>
        </div>
      }

      <main id="main">
        @if (!isFocusContent && !hideGlobalLayout) {
          <mibp-breadcrumbs-v2></mibp-breadcrumbs-v2>
        }
        <router-outlet></router-outlet>
      </main>

    </section>

  </mibp-application-gate>

  @if (!isFocusContent && !hideGlobalLayout) {
    <footer class="application-root__footer">
      <mibp-footer-v2></mibp-footer-v2>
    </footer>
  }

</div>

</section>
